import { ROUTES } from '@/shared/lib';

export const BACKGROUND_REMOVED_ROUTES = [ROUTES.PROFILE];

export const HIDDEN_NAV_PATHS = [
  ROUTES.CREATE_CARD,
  ROUTES.PROFILE,
  ROUTES.ACCOUNT,
  ROUTES.CUSTOMIZE,
];

export const SHOWN_CUSTOMIZATION_BUTTON_PATHS = [ROUTES.ROOT];

export const HIDDEN_AVATAR_PATHS = [ROUTES.PROFILE, ROUTES.CUSTOMIZE];

export const BACK_BUTTON_LINK = {
  [ROUTES.CREATE_CARD]: ROUTES.CARDS,
};

export const TRANSPARENT_PATHS = [ROUTES.ACCOUNT, ROUTES.CUSTOMIZE];
export const SHOW_BACK_BUTTON_PATHS = [ROUTES.PROFILE];
